// extracted by mini-css-extract-plugin
module.exports = {"companies-select":"styles_companies-select__35W5Q"};